/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.DocumentPackager";
        class DocumentPackagerWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("DocumentPackagerWidgetTypeClass.createInstance()");
                    return new DocumentPackagerWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("DocumentPackagerWidgetTypeClass._storeHtml()");
                    DocumentPackagerWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocumentPackagerWidgetTypeClass::constructor");
                if (DocumentPackagerWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/DocumentPackager/document-packager.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.DocumentPackagerWidgetTypeClass = DocumentPackagerWidgetTypeClass;
        class DocumentPackagerWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._noRecords = null;
                this._listHolder = null;
                this._presentAsButtons = null;
                this._buttonsVertical = null;
                this._dataList = null;
                this._buttonPalette = null;
                this._profiles = [];
                this._busyModalSession = null;
                this._activeProfile = null;
                this.presentInstance = () => {
                    this._log.info("UploadDocListWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = DocumentPackagerWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._noRecords = this._container.querySelector('#docPackagerNoRecords');
                    this._listHolder = this._container.querySelector('#docPackagerListHolder');
                    this._widgets.setTitle(this._config, this._container.querySelector('#docPackagerWidgetTitle'), 'STR_WPT_DOC_PACKAGER');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._container.querySelector('#docPackagerNoRecordsMessage'), 'STR_WPT_NO_PACKAGES');
                    if (this._presentAsButtons && !this._buttonsVertical) {
                        this._listHolder.classList.add('widget__body-item--no-padding');
                    }
                    if (this._presentAsButtons) {
                        let usePrimary = false;
                        if (this._config.hasOwnProperty('SuppressHeading') && this._config.SuppressHeading === true) {
                            usePrimary = true;
                        }
                        let bpConfig = {
                            Orientation: this._buttonsVertical ? 'Vertical' : 'Horizontal',
                            SuppressNoItemsBanner: true,
                            UsePrimaryColour: usePrimary
                        };
                        this._buttonPalette = new Widgets.ComponentButtonPalette(this._core, this._listHolder, this, bpConfig, this._packageClicked);
                        this._buttonPalette.present();
                    }
                    else {
                        let listConfig = {
                            SelectItemCallback: this._packageClicked
                        };
                        this._dataList = new Widgets.ComponentDataList(this._core, this._listHolder, this, listConfig);
                        this._dataList.present();
                    }
                    this._populateVisiblePackageList();
                    this._type.instanceReady(this.getHandle());
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("DocumentPackagerWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                };
                this._callFailedHandler = (json) => {
                    this._log.info("DocumentPackagerWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                };
                this._populateVisiblePackageList = () => {
                    this._log.info("DocumentPackagerWidgetInstanceClass._populateVisiblePackageList()");
                    if (this._profiles.length == 0) {
                        this._core.Functions.showElement(this._noRecords);
                        return;
                    }
                    // Tidy first
                    if (this._presentAsButtons) {
                        this._buttonPalette.clearDisplay();
                    }
                    else {
                        this._dataList.clearList();
                    }
                    if (this._presentAsButtons) {
                        let buttonOptions = [];
                        this._profiles.forEach(profile => {
                            let buttonOption = {
                                Identifier: profile.Id,
                                Label: profile.Name
                            };
                            buttonOptions.push(buttonOption);
                        });
                        this._buttonPalette.displayOptions(buttonOptions);
                    }
                    else {
                        let listData = {
                            Items: []
                        };
                        this._profiles.forEach(profile => {
                            let itemData = {
                                Id: profile.Id,
                                DisplayName: profile.Name
                            };
                            listData.Items.push(itemData);
                        });
                        this._dataList.displayData(listData);
                    }
                };
                this._packageClicked = (id) => {
                    this._log.info("DocumentPackagerWidgetInstanceClass._packageClicked()");
                    this._activeProfile = null;
                    let profile = this._profiles.find(p => (p.Id == id));
                    if (profile == null) {
                        this.addError("Unrecognised package profile ID selected.");
                        return;
                    }
                    if (profile.hasOwnProperty('Query') && (profile.Query != null)) {
                        this._activeProfile = profile;
                        let requestSearch = this._core.OBHelper.compileFlexSearchFromQueryDef(profile.Query);
                        requestSearch.SuppressKeywords = true;
                        this._busyModal(true);
                        this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._hitListReceived, {}, this._callErrorHandler, this._callFailedHandler);
                    }
                    else if (profile.hasOwnProperty('FlexQuery') && (profile.FlexQuery != null)) {
                        this._activeProfile = profile;
                        let requestSearch = this._core.OBHelper.flexDefinitionToRequest(profile.FlexQuery);
                        requestSearch.SuppressKeywords = true;
                        this._busyModal(true);
                        this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._hitListReceived, {}, this._callErrorHandler, this._callFailedHandler);
                    }
                    else {
                        this.addError("Package profile has no defined Query or FlexQuery.");
                        return;
                    }
                };
                this._busyModal = (show) => {
                    if (show) {
                        let modalSession = 'doc-packager-' + performance.now();
                        if (this._core.Helper.presentBusyModal(WPTNamespace.ModalType.FIRST, modalSession, "STR_WPT_PROCESSING")) {
                            this._busyModalSession = modalSession;
                        }
                    }
                    else if (this._busyModalSession) {
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                };
                this._hitListReceived = (response) => {
                    this._log.info("DocumentPackagerWidgetInstanceClass._hitListReceived()");
                    if (response.hasOwnProperty('Documents') && response.Documents.length > 0) {
                        let docList = [];
                        response.Documents.forEach(doc => {
                            docList.push(doc.ItemNum.toString());
                        });
                        // Set up request headers
                        let headers = {};
                        headers['dochandles'] = docList.join(',');
                        if (this._activeProfile.FileName)
                            headers['filename'] = this._activeProfile.FileName;
                        headers['nativeformat'] = (this._activeProfile.NativeFormat) ? 'true' : 'false';
                        // Go
                        let url = '/MultiDocumentDownload.ashx?wmode=transparent';
                        this._core.Loader.genericServiceCallRawData(url, this._receiveZipData, this._downloadError, headers);
                    }
                    else {
                        this._activeProfile = null;
                        this._busyModal(false);
                        this._core.Helper.presentWarningModal('STR_WPT_PACKAGE_NO_DOCS');
                    }
                };
                this._receiveZipData = (rawResponse) => {
                    this._log.info("DocumentPackagerWidgetInstanceClass._receiveZipData()");
                    this._busyModal(false);
                    let objectURL = window.URL.createObjectURL(new Blob([rawResponse.ContentRaw]));
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created object URL: " + objectURL);
                    }
                    let tempAnchor = document.createElement('a');
                    tempAnchor.href = objectURL;
                    tempAnchor.download = rawResponse.ContentName;
                    document.body.appendChild(tempAnchor);
                    tempAnchor.click();
                    document.body.removeChild(tempAnchor);
                    window.URL.revokeObjectURL(objectURL);
                    this._activeProfile = null;
                };
                this._downloadError = () => {
                    this._log.info("DocumentPackagerWidgetInstanceClass._downloadError()");
                    this._activeProfile = null;
                    this._busyModal(false);
                    let msg = this._core.Locale.getTranslation("STR_WPT_DOC_DOWNLOAD_FAILED_MSG");
                    console.warn(msg);
                    this._core.Helper.presentWarningModal(msg);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocumentPackagerInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                let conf = config;
                this._buttonsVertical = true;
                if (conf.hasOwnProperty('Type') && conf.Type === 'Buttons') {
                    this._presentAsButtons = true;
                    if (conf.hasOwnProperty('ButtonsVertical') && !conf.ButtonsVertical) {
                        this._buttonsVertical = false;
                    }
                }
                else {
                    this._presentAsButtons = false;
                }
                if (conf.hasOwnProperty('PackageProfiles') && (conf.PackageProfiles != null)) {
                    this._profiles = conf.PackageProfiles;
                    this._profiles.forEach(profile => {
                        DocumentPackagerWidgetInstanceClass._idCounter++;
                        profile.Id = DocumentPackagerWidgetInstanceClass._idCounter.toString();
                        if (!profile.hasOwnProperty('FileName'))
                            profile.FileName = null;
                        if (!profile.hasOwnProperty('NativeFormat'))
                            profile.NativeFormat = false;
                    });
                }
            }
        }
        DocumentPackagerWidgetInstanceClass.HtmlData = null;
        DocumentPackagerWidgetInstanceClass._idCounter = 0;
        Widgets.DocumentPackagerWidgetInstanceClass = DocumentPackagerWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
